import { LayoutDataType } from '../../types';

export const INTERACTION_OPTIONS: {
  id: NonNullable<LayoutDataType['interaction']>;
  title: string;
}[] = [
  {
    id: 'deep_connection',
    title: '💕 Deep Connection',
  },
  {
    id: 'friendship',
    title: '✌️ Friendship',
  },
  {
    id: 'casual_chatting',
    title: '💬 Casual talks',
  },
  {
    id: 'one_night_stand',
    title: '🦋 One Night Stand',
  },
];
